'use strict';

var Promise = require('bluebird');
var getBadCriteriaIds = require('./getBadCriteriaIds');

function loadMarketingTasks (projectUrl) {
  var getTasksUrl;
  var data = {};
  var lang = window.wooGlobal.language;

  if (projectUrl) {
    getTasksUrl = '/' + lang + '/projects/' + projectUrl + '/tasks';
  } else {
    getTasksUrl = '/' + lang + '/tasks';
    data = {
      'criterum-ids': getBadCriteriaIds()
    };
  }

  return Promise.resolve($.ajax({
    type: 'GET',
    cache: false,
    data: data,
    url: getTasksUrl,
    dataType: 'json',
    beforeSend: function (jqXHR, settings) {
      jqXHR.url = settings.url;
      jqXHR.data = settings.data;
    }
  }));
}

module.exports = loadMarketingTasks;
